export default "__VITE_ASSET__0058a78e__"